import { getMostlyAppropiateLangCode } from './get-mostly-appropiate-default-lang-code'
import { get, put } from './inner-store'
import { iLanguage } from './types'

export type iChangeLanguage = (
  newLangCode: string,
) => Promise<iLanguage>

const changeLanguage: iChangeLanguage = async (newLangCode) => {
  const availableLanguages = get('availableLanguages')
  const requestLang = get('requestLang')
  const store = get('store')

  const langCode = getMostlyAppropiateLangCode(
    newLangCode,
    availableLanguages,
  )

  const language = await requestLang(langCode)
  await store.put(langCode)

  put('language', language)
  put('langCode', langCode)

  return language
}

export { changeLanguage }
